import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './config/firebase';
import News from './pages/News';
import Deals from './pages/Deals';
import Shops from './pages/Shops';
import Notifications from './pages/Notifications';
import Feedback from './pages/Feedback';
import Fidelite from './pages/Fidelite';
import BottomNavigation from './components/BottomNavigation';
import Header from './components/Header';
import AppPopup from './components/AppPopup';

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Vérifier s'il y a une redirection en attente
    const redirectRoute = sessionStorage.getItem('notification_redirect');
    if (redirectRoute) {
      // Effacer la redirection stockée
      sessionStorage.removeItem('notification_redirect');
      // Effectuer la redirection
      navigate(redirectRoute);
    }
  }, [navigate]);

  // Récupérer et afficher le popup
  useEffect(() => {
    const fetchPopup = async () => {
      try {
        const popupRef = doc(db, 'config', 'app', 'appPopup', 'current');
        const popupSnap = await getDoc(popupRef);

        if (popupSnap.exists()) {
          const data = popupSnap.data();
          
          // Vérifier si le popup est actif
          if (data.isActive) {
            // Si le popup contient une image, la précharger
            if (data.imageUrl) {
              const img = new Image();
              img.onload = () => {
                // L'image est chargée, afficher le popup
                setPopupData(data);
                setShowPopup(true);
              };
              img.onerror = () => {
                // Erreur de chargement, afficher quand même le popup sans l'image
                console.error('Erreur lors du chargement de l\'image du popup');
                setPopupData(data);
                setShowPopup(true);
              };
              img.src = data.imageUrl;
            } else {
              // Pas d'image, afficher directement
              setPopupData(data);
              setShowPopup(true);
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors de la récupération du popup:', error);
      }
    };

    fetchPopup();
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Mapping des titres en fonction des routes
  const pageTitles = {
    '/': 'Nouveautés',
    '/feedback': 'Suggestions',
    '/news': 'Nouveautés',
    '/deals': 'Bons Plans',
    '/fidelite': 'Avantages',
    '/shops': 'Boutiques',
    '/notifications': 'Notifications',
    // Ajoute d'autres routes si nécessaire
  };

  // Déterminer le titre en fonction de la route actuelle
  const title = pageTitles[location.pathname] || 'Page';

  return (
    <>
      <Header title={title} />
      <main>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageContent><News /></PageContent>} />
            <Route path="/news" element={<PageContent><News /></PageContent>} />
            <Route path="/deals" element={<PageContent><Deals /></PageContent>} />
            <Route path="/fidelite" element={<PageContent><Fidelite /></PageContent>} />
            <Route path="/shops" element={<PageContent><Shops /></PageContent>} />
            <Route path="/notifications" element={<PageContent><Notifications /></PageContent>} />
            <Route path="/feedback" element={<PageContent><Feedback /></PageContent>} />
          </Routes>
        </AnimatePresence>
      </main>
      <BottomNavigation />
      
      {/* Popup d'ouverture d'app */}
      <AppPopup 
        isOpen={showPopup}
        content={popupData}
        onClose={handleClosePopup}
        version={popupData?.version}
      />
    </>
  );
};

// Composant pour wrapper le contenu avec l'animation
const PageContent = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.3, ease: "easeInOut" }}
  >
    {children}
  </motion.div>
);

export default AppContent; 